import { Injectable, inject } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { SysUtilService } from './sysUtil.service';
import { env } from '../../../app.constant';


@Injectable()
export class SABAUDBReportUtilSBSUMService {

    private sysUtil: SysUtilService = inject(SysUtilService);

    private initialPosition = 12;

    // private numberFormat = "#,##0.00";
    private numberFormat = "#,##0.00_);[Red](#,##0.00)";

    private fontStyle = {
        header: { name: 'Times New Roman', size: 10, bold: true },
        content: { name: 'Times New Roman', size: 10 }
    };
    private columns = [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
        'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
        'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD',
        'AE', 'AF', 'AG', 'AH'
    ];
    private columnTitle = [
        'Supplemental Budget', 'Adjustment', 'Adjusted Supplemental Budget',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Allotment Received',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Adjustments (Reduction, Modification)',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Adjusted Total Allotment',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Total',
        '1st Quarter Ending March 31', '2nd Quarter Ending June 30', '3rd Quarter Ending Sept. 30', '4th Quarter Ending Dec. 31', 'Total',
        'Unobligated Allotment', 'Unpaid (Due & Demandable)', 'Unpaid (Not Yet Due & Demandable)', 'Unreleased Approved Budget'
    ];
    private borderStyle: any = {
        thin: { style: 'thin' },
        full: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        },
        topBottom: {
            top: { style: 'thin' },
            bottom: { style: 'thin' }
        },
        leftRight: {
            left: { style: 'thin' },
            right: { style: 'thin' }
        },
        topLeft: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        topRight: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomLeft: {
            bottom: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomRight: {
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    };

    private formula: any = {
        e: `IF(OR(NOT(C*=""),NOT(D*="")),IF(C*="",0,C*)+IF(D*="",0,D*),"")`,
        j: `IF(OR(NOT(F*=""), NOT(G*=""), NOT(H*=""), NOT(I*="")), IF(F*="",0,F*) + IF(G*="",0,G*) + IF(H*="",0,H*) + IF(I*="",0,I*), "")`,
        o: `IF(OR(NOT(K*=""), NOT(L*=""), NOT(M*=""), NOT(N*="")), IF(K*="",0,K*) + IF(L*="",0,L*) + IF(M*="",0,M*) + IF(N*="",0,N*), "")`,
        p: `IF(OR(NOT(F*=""), NOT(K*="")), IF(F*="",0,F*) + IF(K*="",0,K*), "")`,
        q: `IF(OR(NOT(G*=""), NOT(L*="")), IF(G*="",0,G*) + IF(L*="",0,L*), "")`,
        r: `IF(OR(NOT(H*=""), NOT(M*="")), IF(H*="",0,H*) + IF(M*="",0,M*), "")`,
        s: `IF(OR(NOT(I*=""), NOT(N*="")), IF(I*="",0,I*) + IF(N*="",0,N*), "")`,
        t: `IF(OR(NOT(P*=""), NOT(Q*=""), NOT(R*=""), NOT(S*="")), IF(P*="",0,P*) + IF(Q*="",0,Q*) + IF(R*="",0,R*) + IF(S*="",0,S*), "")`,
        y: `IF(OR(NOT(U*=""), NOT(V*=""), NOT(W*=""), NOT(X*="")), IF(U*="",0,U*) + IF(V*="",0,V*) + IF(W*="",0,W*) + IF(X*="",0,X*), "")`,
        ad: `IF(OR(NOT(Z*=""), NOT(AA*=""), NOT(AB*=""), NOT(AC*="")), IF(Z*="",0,Z*) + IF(AA*="",0,AA*) + IF(AB*="",0,AB*) + IF(AC*="",0,AC*), "")`,
        ae: `IF(OR(NOT(T*=""), NOT(Y*="")), IF(T*="",0,T*) - IF(Y*="",0,Y*), "")`,
        ag: `IF(OR(NOT(Y*=""), NOT(AD*=""), NOT(AF*="")), IF(Y*="",0,Y*) - IF(AD*="",0,AD*) - IF(AF*="",0,AF*), "")`,
        ah: `IF(OR(NOT(E*=""), NOT(J*="")), IF(E*="",0,E*) - IF(J*="",0,J*), "")`,
    };

    async generateExcel(content: Array<any>, campus: number, year: number, options: any = { fileName: "SABAUDB", sheetName: "Sheet1" }) {

        this.columnTitle[0] = `PRE PY ${year}`;

        let data = [];

        let processedData = content.map((d: any) => {
            let dt = JSON.parse(JSON.stringify(d));
            dt.fnd_name = d.fnd_name.replaceAll(/(<([^>]+)>)|(\&nbsp;)/ig, '');

            dt.appr_amount = Number(dt.appr_amount_sb || 0) + Number(dt.appr_amount_cb || 0);
            dt.adjustment_amount = Number(dt.adjustment_amount_sb || 0) + Number(dt.adjustment_amount_cb || 0);
            dt.adjusted_amount = Number(dt.adjusted_amount_sb || 0) + Number(dt.adjusted_amount_cb || 0);
            dt.q1 = Number(dt.q1_sb || 0) + Number(dt.q1_cb || 0);
            dt.q2 = Number(dt.q2_sb || 0) + Number(dt.q2_cb || 0);
            dt.q3 = Number(dt.q3_sb || 0) + Number(dt.q3_cb || 0);
            dt.q4 = Number(dt.q4_sb || 0) + Number(dt.q4_cb || 0);
            dt.total_allotment = Number(dt.q1_sb || 0) + Number(dt.q1_cb || 0) + Number(dt.q2_sb || 0) + Number(dt.q2_cb || 0) + Number(dt.q3_sb || 0) + Number(dt.q3_cb || 0) + Number(dt.q4_sb || 0) + Number(dt.q4_cb || 0);
            dt.re_q1 = Number(dt.re_q1_sb || 0) + Number(dt.re_q1_cb || 0);
            dt.re_q2 = Number(dt.re_q2_sb || 0) + Number(dt.re_q2_cb || 0);
            dt.re_q3 = Number(dt.re_q3_sb || 0) + Number(dt.re_q3_cb || 0);
            dt.re_q4 = Number(dt.re_q4_sb || 0) + Number(dt.re_q4_cb || 0);
            dt.re_total = Number(dt.re_total_sb || 0) + Number(dt.re_total_cb || 0);
            dt.adj_q1 = Number(dt.adj_q1_sb || 0) + Number(dt.adj_q1_cb || 0);
            dt.adj_q2 = Number(dt.adj_q2_sb || 0) + Number(dt.adj_q2_cb || 0);
            dt.adj_q3 = Number(dt.adj_q3_sb || 0) + Number(dt.adj_q3_cb || 0);
            dt.adj_q4 = Number(dt.adj_q4_sb || 0) + Number(dt.adj_q4_cb || 0);
            dt.total_adj = Number(dt.total_adj_sb || 0) + Number(dt.total_adj_cb || 0);
            dt.ors_q1 = Number(dt.ors_q1_sb || 0) + Number(dt.ors_q1_cb || 0);
            dt.ors_q2 = Number(dt.ors_q2_sb || 0) + Number(dt.ors_q2_cb || 0);
            dt.ors_q3 = Number(dt.ors_q3_sb || 0) + Number(dt.ors_q3_cb || 0);
            dt.ors_q4 = Number(dt.ors_q4_sb || 0) + Number(dt.ors_q4_cb || 0);
            dt.ors_total = Number(dt.ors_total_sb || 0) + Number(dt.ors_total_cb || 0);
            dt.dis_q1 = Number(dt.dis_q1_sb || 0) + Number(dt.dis_q1_cb || 0);
            dt.dis_q2 = Number(dt.dis_q2_sb || 0) + Number(dt.dis_q2_cb || 0);
            dt.dis_q3 = Number(dt.dis_q3_sb || 0) + Number(dt.dis_q3_cb || 0);
            dt.dis_q4 = Number(dt.dis_q4_sb || 0) + Number(dt.dis_q4_cb || 0);
            dt.dis_total = Number(dt.dis_total_sb || 0) + Number(dt.dis_total_cb || 0);
            dt.ors_unobligated_allotment = Number(dt.ors_unobligated_allotment_sb || 0) + Number(dt.ors_unobligated_allotment_cb || 0);
            dt.due_demandable = Number(dt.due_demandable_sb || 0) + Number(dt.due_demandable_cb || 0);
            dt.not_yet_due = Number(dt.not_yet_due_sb || 0) + Number(dt.not_yet_due_cb || 0);
            dt.unreleased_appr_amount = Number(dt.unreleased_appr_amount_sb || 0) + Number(dt.unreleased_appr_amount_cb || 0);

            const exempted = ['fnd_name', 'acct_uacs_code', 'due_demandable', 'not_yet_due'];
            Object.keys(dt).forEach((key: string) => {
                if (!exempted.includes(key)) {
                    dt[key] = (Number(dt[key]) == 0) ? "" : Number(dt[key]);
                }
            });

            return dt;
        });

        const wb = new ExcelJS.Workbook();
        const ws = wb.addWorksheet(options.sheetName);
        // const ws = wb.getWorksheet(options.sheetName);

        const imagePath = './assets/BatStateULogo.png';

        this.sysUtil.getBase64ImageFromUrl(imagePath).then(async (result: any) => {
            let imageId = wb.addImage({
                base64: result,
                extension: 'png'
            });
            ws.addImage(imageId, {
                tl: { col: 7, row: 0 },
                ext: { width: 120, height: 110 }
            });

            ws.columns = [
                { header: "", key: "fnd_name", width: 46 },
                { header: "", key: "acct_uacs_code", width: 15 },
                { header: "", key: "appr_amount", width: 16 },
                { header: "", key: "adjustment_amount", width: 16 },
                { header: "", key: "adjusted_amount", width: 16 },
                { header: "", key: "q1", width: 16 },
                { header: "", key: "q2", width: 16 },
                { header: "", key: "q3", width: 16 },
                { header: "", key: "q4", width: 16 },
                { header: "", key: "total_allotment", width: 16 },
                { header: "", key: "re_q1", width: 16 },
                { header: "", key: "re_q2", width: 16 },
                { header: "", key: "re_q3", width: 16 },
                { header: "", key: "re_q4", width: 16 },
                { header: "", key: "re_total", width: 16 },
                { header: "", key: "adj_q1", width: 16 },
                { header: "", key: "adj_q2", width: 16 },
                { header: "", key: "adj_q3", width: 16 },
                { header: "", key: "adj_q4", width: 16 },
                { header: "", key: "total_adj", width: 16 },
                { header: "", key: "ors_q1", width: 16 },
                { header: "", key: "ors_q2", width: 16 },
                { header: "", key: "ors_q3", width: 16 },
                { header: "", key: "ors_q4", width: 16 },
                { header: "", key: "ors_total", width: 16 },
                { header: "", key: "dis_q1", width: 16 },
                { header: "", key: "dis_q2", width: 16 },
                { header: "", key: "dis_q3", width: 16 },
                { header: "", key: "dis_q4", width: 16 },
                { header: "", key: "dis_total", width: 16 },
                { header: "", key: "ors_unobligated_allotment", width: 16 },
                { header: "", key: "due_demandable", width: 16 },
                { header: "", key: "due_demandable", width: 16 },
                { header: "", key: "due_demandable", width: 20 },

            ];

            console.log(`total_content`, data);

            this.setHeader(ws, Number(campus), Number(year));

            let position = this.initialPosition + 4;
            processedData.forEach((data: any, i: number) => {
                ws.addRow(data);
                this.columns.forEach((col: string, index: number) => {
                    let cell = ws.getCell(`${col}${position + i}`);
                    if (index >= 2 && Object.keys(this.formula).includes(col.toLowerCase())) {
                        cell.value = { formula: `${this.formula[col.toLowerCase()].replaceAll('*', (position + i))}`, date1904: false };
                    }
                    cell.style = { numFmt: this.numberFormat };
                    cell.font = (data.aa_fnd_sysref_code == '') ? this.fontStyle.header : this.fontStyle.content;
                    cell.border = this.borderStyle.full;
                    cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (col == 'A') ? 'left' : 'right' };
                });
            });

            const arrayData = await wb.xlsx.writeBuffer();
            const blob = new Blob([arrayData], { type: "application/octet-binary" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${options.fileName}.xlsx`;
            a.click();
            a.remove();

        });
    }

    private setHeader(ws: ExcelJS.Worksheet, campus: number, year: number) {
        let position = this.initialPosition + 1;

        // header title
        ws.mergeCells(`A1:AA1`);
        let row1 = ws.getCell(`A1`);
        row1.value = "Republic of the Philippines";
        row1.font = this.fontStyle.content;
        row1.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A2:AA2`);
        let row2 = ws.getCell(`A2`);
        row2.value = "BATANGAS STATE UNIVERSITY";
        row2.font = this.fontStyle.header;
        row2.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A3:AA3`);
        let row3 = ws.getCell(`A3`);
        row3.value = "The National Engineering University";
        row3.font = this.fontStyle.header;
        row3.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        let campusData = env.campuses.find((c: any) => c.value == campus);
        ws.mergeCells(`A4:AA4`);
        let row4 = ws.getCell(`A4`);
        row4.value = `${campusData.details.name}`;
        row4.font = this.fontStyle.header;
        row4.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A5:AA5`);
        let row5 = ws.getCell(`A5`);
        row5.value = `${campusData.details.addr}`;
        row5.font = this.fontStyle.content;
        row5.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A6:AA6`);
        let row6 = ws.getCell(`A6`);
        row6.value = `Tel Nos.: ${campusData.details.contact}`;
        row6.font = this.fontStyle.content;
        row6.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A7:AA7`);
        let row7 = ws.getCell(`A7`);
        row7.value = `E-mail Address: ${campusData.details.email} | Website Address: https://batstate-u.edu.ph`;
        row7.font = this.fontStyle.content;
        row7.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A9:AA9`);
        let row9 = ws.getCell(`A9`);
        row9.value = "Summary of Approved Budget, Allotment, Utilizations & Balances (SABAUD)";
        row9.font = this.fontStyle.header;
        row9.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A10:AA10`);
        let row10 = ws.getCell(`A10`);
        row10.value = `Supplemental Budget FY ${year}`;
        row10.font = this.fontStyle.header;
        row10.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A11:AA11`);
        let row11 = ws.getCell(`A11`);
        row11.value = `as of ${year}`;
        row11.font = this.fontStyle.header;
        row11.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        // header body
        let ctRow = ws.getRow(position + 1);
        ctRow.height = 56;

        ws.mergeCells(`A${position}:A${position + 1}`);
        let particulars = ws.getCell(`A${position + 1}`);
        particulars.value = "Particulars";
        particulars.font = this.fontStyle.header;
        particulars.border = this.borderStyle.full;
        particulars.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`B${position}:B${position + 1}`);
        let uacs_code = ws.getCell(`B${position + 1}`);
        uacs_code.value = "UACS Code";
        uacs_code.font = this.fontStyle.header;
        uacs_code.border = this.borderStyle.full;
        uacs_code.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`C${position}:E${position}`);
        let approved_budget = ws.getCell(`C${position}`);
        approved_budget.value = "Approved Budget";
        approved_budget.font = this.fontStyle.header;
        approved_budget.border = this.borderStyle.full;
        approved_budget.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`F${position}:T${position}`);
        let allotment = ws.getCell(`F${position}`);
        allotment.value = "Allotments";
        allotment.font = this.fontStyle.header;
        allotment.border = this.borderStyle.full;
        allotment.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`U${position}:Y${position}`);
        let utilizations = ws.getCell(`U${position}`);
        utilizations.value = "Utilizations";
        utilizations.font = this.fontStyle.header;
        utilizations.border = this.borderStyle.full;
        utilizations.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`Z${position}:AD${position}`);
        let disbursement = ws.getCell(`Z${position}`);
        disbursement.value = "Disbursement";
        disbursement.font = this.fontStyle.header;
        disbursement.border = this.borderStyle.full;
        disbursement.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AE${position}:AH${position}`);
        let balances = ws.getCell(`AE${position}`);
        balances.value = "Balances";
        balances.font = this.fontStyle.header;
        balances.border = this.borderStyle.full;
        balances.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };


        this.columns.filter((l: string) => l != 'A' && l != 'B').forEach((t: string, i: number) => {
            let ct = ws.getCell(`${t}${position + 1}`);
            ct.value = this.columnTitle[i];
            ct.font = this.fontStyle.header;
            ct.border = this.borderStyle.full;
            ct.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
        });


        // numbers in cell
        const cellNumberFormula = {
            5: "5=3+4",
            10: "10=6+7+8+9",
            15: "15=11+12+13+14",
            16: "16=6+11",
            17: "17=7+12",
            18: "18=8+13",
            19: "19=9+14",
            20: "20=16+17+18+19",
            25: "25=21+22+23+24",
            30: "30=26+27+28+29",
            31: "31=20-25",
            33: "33=25-30-32",
            34: "34=5-10"
        };
        this.columns.forEach((l: string, i: number) => {
            let numCell = ws.getCell(`${l}${position + 2}`);
            let n = i + 1;
            numCell.value = (Object.keys(cellNumberFormula).includes(n.toString())) ? cellNumberFormula[n] : `${n}`;
            numCell.font = this.fontStyle.header;
            numCell.border = this.borderStyle.full;
            numCell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
        });
    }

}
